import axios from "axios";
import spinnerInterceptor from "../interceptors/spinner.interceptor";

const http = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "application/json"
  }
});

spinnerInterceptor.wrapAxios(http);

function fetchInteractWebSettings(path, showSpinner = true, applyToken = true) {
  return http.get(`/connect/v5/interactweb/${path}`, {
    showSpinner,
    applyToken
  });
}
export default {
  fetchInteractWebSettings
};
